var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.70312C6.19416 6.70312 6.35156 6.54573 6.35156 6.35156C6.35156 6.1574 6.19416 6 6 6C5.80584 6 5.64844 6.1574 5.64844 6.35156C5.64844 6.54573 5.80584 6.70312 6 6.70312Z",
    fill: "#535151",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6963 0 0 2.69646 0 6C0 9.30377 2.69646 12 6 12C9.30375 12 12 9.30354 12 6C12 2.6963 9.30354 0 6 0ZM6 1.42969C8.28101 1.42969 10.177 3.10941 10.5162 5.29688H9.29702C8.52401 5.29688 7.78957 4.98668 7.28203 4.44584C6.58828 3.70648 5.41179 3.70624 4.71797 4.44581C4.21043 4.98668 3.47599 5.29688 2.70295 5.29688H1.48378C1.82299 3.10941 3.71899 1.42969 6 1.42969ZM6 7.40625C5.41847 7.40625 4.94531 6.93314 4.94531 6.35156C4.94531 5.76998 5.41847 5.29688 6 5.29688C6.58158 5.29688 7.05469 5.76998 7.05469 6.35156C7.05469 6.93314 6.58158 7.40625 6 7.40625ZM1.74422 7.66634C2.14664 7.50846 2.43722 7.40625 2.83594 7.40625C4.11769 7.40625 5.11451 8.54845 4.92143 9.8318H4.92061C4.89192 10.0282 4.83548 10.2186 4.75409 10.3977C3.37692 10.007 2.26245 8.9853 1.74422 7.66634ZM7.24619 10.3976C7.16257 10.2137 7.10735 10.0234 7.07939 9.8318H7.07857C6.85359 8.33637 8.23406 7.10245 9.66499 7.46611C9.81584 7.50445 10.0046 7.56783 10.2558 7.66636C9.73758 8.98521 8.62322 10.0069 7.24619 10.3976Z",
    fill: "#535151",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.b4796ad4f1aa18990797bed9b4c21afe.svg";
export { ForwardRef as ReactComponent };